var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0494 11.6553C16.556 11.6553 14.5275 13.6839 14.5275 16.1773C14.5275 18.6709 16.556 20.6994 19.0494 20.6994C21.5429 20.6994 23.5714 18.6708 23.5714 16.1773C23.5714 13.6838 21.5429 11.6553 19.0494 11.6553Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4303 36.5877H39.7277C39.7277 34.9465 39.7277 8.47626 39.7277 6.84211C39.7277 5.97516 39.0248 5.27238 38.158 5.27238H8.41228V1.56973C8.41228 0.702861 7.70941 0 6.84255 0C5.9756 0 5.27282 0.702861 5.27282 1.56973V5.27273H1.56973C0.702861 5.27273 0 5.9756 0 6.84255C0 7.7095 0.702861 8.41228 1.56973 8.41228H5.27229C5.27229 9.63079 5.27229 36.7859 5.27229 38.1579C5.27229 39.0248 5.97516 39.7276 6.84202 39.7276H36.5876V43.4302C36.5876 44.2971 37.2905 44.9999 38.1574 44.9999C39.0243 44.9999 39.7271 44.2971 39.7271 43.4302V39.7272H43.4301C44.2971 39.7272 44.9998 39.0243 44.9998 38.1575C45 37.2906 44.2971 36.5877 43.4303 36.5877ZM36.5882 22.8448L32.1101 18.099C31.4979 17.45 30.4494 17.4389 29.8265 18.0991L19.9318 28.5886L15.1787 23.5494C14.56 22.8931 13.5126 22.8951 12.8949 23.5494L8.41184 28.3017V8.41184H36.5881V22.8448H36.5882Z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_1112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.de6e9456d01a0cfd9cf46d6f67a87655.svg";
export { ForwardRef as ReactComponent };